import { useQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import { compose } from 'redux';

// @ts-expect-error untyped module reference-resolvers
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import ObjectType from 'automation-ui-references/object-types/ObjectType';
import { getCustomObjectResolverOptions } from 'automation-ui-enrollment/utils/properties/inboundDbObjectUtils';
import { GET_OBJECT_TYPE_BY_ID } from 'automation-ui-enrollment/queries/ObjectTypesQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const emptyObjectType = new ObjectType();
const queryObjectTypeById = WrappedComponent => props => {
  const {
    objectTypeId,
    flowObjectTypeId
  } = props;
  const id = objectTypeId || flowObjectTypeId;
  const {
    data,
    loading
  } = useQuery(GET_OBJECT_TYPE_BY_ID, {
    skip: !id,
    variables: {
      objectTypeId: id
    }
  });
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    objectType: get(data, 'enrollment_objectTypeById', emptyObjectType),
    objectTypeLoading: loading
  }));
};
export const WiredCustomObjectResolverPropInterface = {
  objectTypeId: ObjectTypeIdType,
  flowObjectTypeId: ObjectTypeIdType
};
const wireCustomObjectResolver = WrappedComponent => {
  const connectResolver = ConnectReferenceResolvers((resolvers, {
    objectTypeId,
    flowObjectTypeId,
    objectType,
    objectTypeLoading,
    includeDeletes = false
  }) => {
    if (objectTypeLoading) {
      return {};
    }
    // @ts-expect-error CUSTOM_OBJECT doesnt exist on resolvers
    const {
      resolverFactory,
      resolversCache
    } = resolvers.CUSTOM_OBJECT();
    const options = getCustomObjectResolverOptions(objectType, includeDeletes);
    const CustomObjectResolver = resolverFactory(objectTypeId || flowObjectTypeId, options);
    const resolver = CustomObjectResolver(resolversCache);
    return {
      resolver
    };
  });
  return compose(queryObjectTypeById, connectResolver)(WrappedComponent);
};
export default wireCustomObjectResolver;